import { render, staticRenderFns } from "./DataGridWidget.vue?vue&type=template&id=357825a2&scoped=true&"
import script from "./DataGridWidget.vue?vue&type=script&lang=ts&"
export * from "./DataGridWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DataGridWidget.vue?vue&type=style&index=0&id=357825a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357825a2",
  null
  
)

export default component.exports